export const STORE_ID = {
  ORDERING: 'ordering',
  GIFT_CARDS: 'gift-cards',
  MAD_BUNDAY: 'mad-bunday'
}

export type StoreId = 'ordering' | 'gift-cards' | 'mad-bunday'
